import { useEffect, useState } from 'react'
import { personFromName, type Person } from '@/components/tickets/data'
import { api } from '@/services/api'

interface ApiUser {
  id: string
  nom: string
  role: string
}

/** Collaborateurs Qolaig (admins / super admins), chargés quand `enabled` passe à true. */
export function useInternalPeople(enabled: boolean): { people: Person[]; loading: boolean } {
  const [people, setPeople] = useState<Person[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    setLoading(true)
    api
      .get<{ data: ApiUser[]; count: number }>('/users', { internal: 'true' })
      .then((response) => {
        if (cancelled) return
        setPeople(
          (response.data.data || [])
            .filter((user) => user.role === 'admin' || user.role === 'super_admin')
            .map((user) => personFromName(user.id, user.nom))
            .sort((a, b) => a.name.localeCompare(b.name, 'fr'))
        )
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des collaborateurs:', error)
        if (!cancelled) setPeople([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [enabled])

  return { people, loading }
}
